export const SET_DELETE_STATE="SET_DELETE_STATE"

export const DELETE_LECTURE_REQUEST="DELETE_LECTURE_REQUEST"
export const DELETE_LECTURE_SUCCESS="DELETE_LECTURE_SUCCESS"
export const DELETE_LECTURE_FAILURE="DELETE_LECTURE_FAILURE"